import type { shell as EN } from '../en/shell';

export const shell: Record<keyof typeof EN, string> = {
  'shell.error.title': 'Etwas ist schiefgelaufen.',
  'shell.error.retry': 'Erneut versuchen',
  'shell.error.paneTitle': 'Dieser Bereich konnte nicht angezeigt werden.',
  'shell.error.routeTitle': 'Diese Seite konnte nicht angezeigt werden.',
  'shell.error.backToNotebook': 'Zurück zum Notizbuch',
  'shell.error.body': 'Dieser Teil der App ist abgestürzt. Deine Arbeit ist lokal gespeichert.',
  'shell.error.reload': 'Neu laden',
  'shell.error.tryAgain': 'Erneut versuchen',
  'shell.error.technicalDetails': 'Technische Details',

  'shell.sidebar.nav': 'Notizbuch',
  'shell.sidebar.favorites': 'Favoriten',
  'shell.sidebar.calendar': 'Kalender',
  'shell.sidebar.chat': 'Chat',
  'shell.sidebar.settings': 'Einstellungen',

  'shell.topbar.breadcrumb': 'Notizbuch',
  'shell.topbar.sidebar.show': 'Seitenleiste einblenden',
  'shell.topbar.sidebar.hide': 'Seitenleiste ausblenden',
  'shell.topbar.sidebar.toggleTitle': 'Seitenleiste umschalten (Mod+\\)',
  'shell.topbar.rightPanel.show': 'Kontextbereich einblenden',
  'shell.topbar.rightPanel.hide': 'Kontextbereich ausblenden',
  'shell.topbar.rightPanel.toggleTitle': 'Kontextbereich umschalten (Mod+.)',
  'shell.topbar.theme.system': 'System',
  'shell.topbar.theme.light': 'Hell',
  'shell.topbar.theme.dark': 'Dunkel',
  'shell.topbar.theme.aria': 'Design: {theme}. Wechseln zu {next}.',
  'shell.topbar.theme.title': 'Design: {theme} — klicken für {next}',
  'shell.topbar.signOut': 'Abmelden',

  'shell.sync.kind.create': 'Neue Seite',
  'shell.sync.kind.update': 'Inhalt',
  'shell.sync.kind.move': 'Verschieben',
  'shell.sync.kind.archive': 'Archivieren',
  'shell.sync.kind.restore': 'Wiederherstellen',
  'shell.sync.kind.delete': 'Löschen',
  'shell.sync.age.seconds': 'vor {count}s',
  'shell.sync.age.minutes': 'vor {count}m',
  'shell.sync.age.hours': 'vor {count}h',
  'shell.sync.saved': 'Gespeichert',
  'shell.sync.savedAt': 'Gespeichert um {time}',
  'shell.sync.nothingPending': 'Nichts ausstehend',
  'shell.sync.saving': 'Speichert…',
  'shell.sync.savingTitle': 'Ein Schreibvorgang läuft. Der Entwurf ist bereits auf diesem Gerät.',
  'shell.sync.pending.one': 'Offline — {count} ausstehend',
  'shell.sync.pending.other': 'Offline — {count} ausstehend',
  'shell.sync.signInToSync.one':
    'Melde dich an, um {count} ausstehende Änderung zu synchronisieren.',
  'shell.sync.signInToSync.other':
    'Melde dich an, um {count} ausstehende Änderungen zu synchronisieren.',
  'shell.sync.offlineSaved':
    'Auf diesem Gerät gespeichert. Wird synchronisiert, sobald der Server erreichbar ist.',
  'shell.sync.offlineNotice':
    'Deine Änderungen sind auf diesem Gerät gespeichert und werden synchronisiert, sobald du wieder online bist.',
  'shell.sync.conflict': 'Konflikt',
  'shell.sync.conflictTitle': 'Erfordert eine Entscheidung. Nichts ist verloren gegangen.',
  'shell.sync.empty': 'Alles ist synchronisiert. Nichts wartet.',
  'shell.sync.attempts.one': '{count} Versuch',
  'shell.sync.attempts.other': '{count} Versuche',
  'shell.sync.failed': 'fehlgeschlagen',
  'shell.sync.discard': 'Verwerfen',
  'shell.sync.retryAll': 'Alle erneut versuchen',
  'shell.sync.discardDialog.title': 'Diese Änderung verwerfen?',
  'shell.sync.discardDialog.contentBody':
    'Der ungespeicherte Inhalt von „{label}“ wird endgültig verworfen. Kopiere ihn zuerst, wenn du ihn behalten möchtest.',
  'shell.sync.discardDialog.genericBody': 'Diese Änderung ({kind}) wird endgültig verworfen.',
  'shell.sync.discardDialog.copyContent': 'Inhalt kopieren',
  'shell.sync.discardDialog.copiedToast': 'In die Zwischenablage kopiert.',
  'shell.sync.discardDialog.thisPage': 'diese Seite',

  'shell.rightPanel.aria': 'Kontext',
};
